import axios from 'axios';

const dadataHeader = {
  Accept: 'application/json, text/javascript, */*; q=0.01',
  Authorization: 'Token 0d79de414e70a03a38147fc945cf0a333ee871ec',
  'Content-Type': 'application/json',
};
const initialFormData = {
  inn: '',
  company_name: '',
  company_ur_name: '',
  company_ur_address: '',
  factAddress: '',
  addresses: [],
};

export default {
  name: 'RttTableAdd',
  data() {
    return {
      isActive: false,
      valid: false,
      address_data: null,
      suggestions: [],
      formData: { ...initialFormData },
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        inn: v => (!v || !v.length || v.length === 10 || v.length === 12) || 'ИНН может содержать 10 или 12 символов',
        name: v => (!v || !v.length || v.length > 1) || 'Введите корректное название торговой токи',
        factAddress: v => !!v || 'Укажите адрес',
      },
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    'formData.inn': function (val) {
      if (val && val.length) {
        if (val && val.length >= 10) {
          const app = this;
          const info = { count: 20, query: val };
          const config = {
            headers: { ...dadataHeader, 'X-Secret': '3405f3b2a53814b5b68826b2b5bb1d3db3e55846' },
          };

          axios.post('https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party', info, config)
            .then((res) => {
              if (res.data?.suggestions?.length) {
                app.formData.company_ur_name = res.data.suggestions[0]
                  .data?.name?.full_with_opf;
                app.formData.company_ur_address = res.data.suggestions[0]
                  .data?.address?.unrestricted_value;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    isActive(val) {
      if (!val) {
        this.ClearForm();
      }
    },
  },
  computed: {
    loading() { return this.$store.state.loading; },
    cantSave() {
      return this.loading || !this.valid
        || !(this.address_data?.house || this.formData.addresses.length);
    },
  },
  methods: {
    AddAddress() {
      this.formData.addresses.push(this.formData.factAddress);
      this.formData.addresses = [...new Set(this.formData.addresses)];
      this.formData.factAddress = '';
      this.address_data = null;
    },
    DeleteAddress(name) {
      this.formData.addresses = this.formData.addresses
        .filter(i => i.toLowerCase() !== name.toLowerCase());
    },
    ClearForm() {
      if (this.$refs.form && typeof this.$refs.form.reset === 'function') {
        this.$refs.form.reset();
        this.formData = { ...initialFormData, addresses: [] };
        this.address_data = null;
        this.suggestions = [];
      }
    },
    Submit() {
      this.formData.addresses.push(this.formData.factAddress);
      this.formData.addresses = [...new Set(this.formData.addresses)];
      this.formData.factAddress = '';
      this.$emit('submit', { ...this.formData });
      this.isActive = false;
    },
    AutocompleteSearch(queryString, cb) {
      if (!queryString) return;
      const app = this;
      const info = { count: 20, query: queryString };
      const config = { headers: dadataHeader };

      axios.post('https://dadata.ru/api/v2/suggest/address', info, config)
        .then((res) => {
          app.suggestions = res.data.suggestions;
          cb(app.suggestions);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    AutocompleteSelect(item) {
      this.suggestions.forEach((sug) => {
        if (sug.value === item.value) {
          this.address_data = sug.data;
        }
      });
    },
  },
};
